import useSelector from '@app/hooks/useSelector'
import { getFeatureState } from '@app/selectors'

export type Feature =
	| 'homeFeatureLqai'
	| 'lionLfcFilesManagement'
	| 'lionFeatureFilesManagementBulkActions'
	| 'trexFeatureAutomaticTranslations'
	| 'perfFeatureReportingEngine'
	| 'homeFeatureAiLqaSuggestions'
	| 'homeFeatureAibilling'
	| 'homeBugfixAiTaskSaveTemplate'
	| 'homeFeatureAutomaticTranslationUse100TMMatch'
	| 'homeFeatureAutomaticTranslationUseFuzzyMatch'
	| 'homeMarketingBeta'
	| 'growthSubscriptionExtras'
	| 'growthCancellationFlow'
	| 'growthPricingV2'
	| 'growthPricingBundlesV2'
	| 'growthPricingV2WipUsageOverview'
	| 'metroWorkflowsManagement'
	| 'metroWorkflowsCreateCustomScratch'
	| 'metroWorkflowStatusReporting'
	| 'metroWorkflowsGa'
	| 'metroFeatureTemplateTriggerGates'
	| 'metroCustomWorkflows'
	| 'metroFeatureWorkflowsAiScoring'
	| 'metroFeatureWorkflowsInBranches'
	| 'metroFeatureWorkflowsFlexibleSchedules'
	| 'maxMigrationForm'
	| 'gitLabRecursivePullEnabled'
	| 'perfFeatureAsyncExport'
	| 'exportAppleStringsReplaceU2028Disabled'
	| 'translationsScoringDisabled'
	| 'translationsFeatureRagSelfServe'
	| 'translationsFeatureRagSelfServeM2'
	| 'translationsAiProfileUpsellBanner'
	| 'nextGenFeatureMarketingAssets'
	| 'experimentEmberAiAssistant'
	| 'experimentGenerateStyleGuide'
	| 'growthExperimentGro443downloadaa'
	| 'growthExperimentGro443downloadaauser'
	| 'expEntitlementAlertCtaCopy'

export const useFeatureState = (feature: Feature): string | boolean | undefined => {
	const featureState = useSelector((state) => getFeatureState(state.features, feature))

	return featureState !== null ? featureState : undefined
}
